import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SmInputComponent} from '../../form-controls/sm-input/sm-input.component';
import {SmContextMenuItemModel, type SmContextMenuSelectionStyle} from '../sm-context-menu-item/sm-context-menu-item.component';

@Component({
  selector: 'sm-search-control',
  templateUrl: './sm-search-control.component.html',
  styleUrls: ['./sm-search-control.component.scss'],
  standalone: false,
})
export class SmSearchControlComponent {
  @ViewChild(SmInputComponent) private input?: SmInputComponent;

  async focus(): Promise<void> {
    await this.input?.focus();
  }

  @Input() value = '';
  @Input() disabled = false;
  @Input() label = '';
  @Input() scannedType: 'qr' | 'barcode' | null = null;
  @Input() scannedTypeLabel = '';
  @Input() placeholder = '';
  @Input() searchAriaLabel = '';
  @Input() searchModeAriaLabel = '';
  @Input() scanAriaLabel = '';
  @Input() scanTitle = '';
  @Input() showModeMenu = true;
  @Input() showScanner = true;
  @Input() showSearchButton = false;
  @Input() selectedModeId = '';
  @Input() modeItems: SmContextMenuItemModel[] = [];
  @Input() modeSelectionStyle: SmContextMenuSelectionStyle = 'radio';

  @Output() valueChange = new EventEmitter<string>();
  @Output() selectedModeIdChange = new EventEmitter<string>();
  @Output() scanClick = new EventEmitter<void>();
  @Output() searchRequested = new EventEmitter<void>();
  @Output() compositionStarted = new EventEmitter<void>();
  private composing = false;

  startComposition(): void {
    this.composing = true;
    this.compositionStarted.emit();
  }

  endComposition(event: CompositionEvent): void {
    this.composing = false;
    this.handleValueInput((event.target as HTMLInputElement).value);
  }

  requestSearch(event: Event): void {
    event.preventDefault();
    if (!this.disabled && !this.composing && !(event as KeyboardEvent).isComposing) this.searchRequested.emit();
  }

  handleValueInput(nextValue: string): void {
    if (this.disabled) return;
    this.value = nextValue;
    if (!this.composing) this.valueChange.emit(nextValue);
  }

  handleModeSelect(item: SmContextMenuItemModel): void {
    if (this.disabled) return;
    this.selectedModeId = item.id;
    this.selectedModeIdChange.emit(item.id);
  }

  handleScanClick(): void {
    if (this.disabled) return;
    this.scanClick.emit();
  }

  get inputPaddingEnd(): string {
    const modeMenu = this.showModeMenu && !this.disabled;
    return modeMenu && this.showScanner ? '6.8rem' : modeMenu || this.showScanner ? '3.8rem' : '1rem';
  }

  get scanButtonLabel(): string {
    return this.scannedType && this.scannedTypeLabel
      ? `${this.scanAriaLabel}: ${this.scannedTypeLabel}`
      : this.scanAriaLabel;
  }

  get resolvedModeItems(): SmContextMenuItemModel[] {
    return this.modeItems.map((item) => ({
      ...item,
      selected: item.id === this.selectedModeId,
      checked: item.id === this.selectedModeId,
    }));
  }
}
